module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAXCAYAAADk3wSdAAAAyElEQVR42mJ8ZmbGQCTwAuJtxChkItLAJCDeCsQJ1DLUHIinQ9nTgNiEUkPFgXgNELNB+ZxAvA6IRck1lA1qoAyauCwQrwJiFnIMnQDENjjkHIC4m1RDk4E4k0DQFABxDLGGWkAjhBgwE4gNCRkqAcSrkSKGEODCFnFMREQMIaAAxMuAmBmboZOA2JqBPOACxJ3ohqYAcToDZaAYiMMZkNLaSSw55QwBQ75AkxYy+I5s6GUyXPYXiM9SUqCQBEYNHTV0KBgKEGAAKuAadfA6DxgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/redup.png
// module id = cHJY
// module chunks = 1